import React, {
  FC,
  forwardRef,
  memo,
  Children,
  ReactNode,
  isValidElement,
  cloneElement,
} from 'react';
import Icon from '../Icon';
import LongArrowRight from '../Icon/icons/outlined/long-arrow-right';
import { StepProps } from './Step/types';
import { StepperProps } from './types';
import {
  StepperContainer,
  ConnectorContainer,
} from './styles';

const Stepper: FC<StepperProps> = forwardRef<HTMLDivElement, StepperProps>(({
  children,
  activeStepIdx,
  ...restProps
}, ref) => {
  const steps = Children.toArray(children);
  const stepsWithConnector = steps.reduce<
    ReactNode[]
  >((acc, curr, idx) => {
    // curr is Step component
    const isValid = isValidElement(curr);
    const newStep = isValid
      ? cloneElement(curr as React.ReactElement<StepProps>, {
        active: activeStepIdx === idx,
      })
      : curr;

    if (idx === steps.length - 1) {
      return [...acc, newStep];
    } else {
      const Connector = (
        <div
          key={`${idx}_connector`}
          className={ConnectorContainer}
        >
          <Icon icon={LongArrowRight} />
        </div>
      );

      return [...acc, newStep, Connector];
    }
  }, []);

  return (
    <div
      ref={ref}
      className={StepperContainer}
      {...restProps}
    >
      {stepsWithConnector}
    </div>
  );
});

export default memo(Stepper);
